import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  checked?: boolean
}
export const Root = styled.div`
  display: block;
  width:auto;
  height:37px;
  padding: 0px 24px;
  position:relative;
  text-align: left;
  &:hover {
  }
`

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

export const Icon = styled.svg`
  fill: none;
  stroke: #204078;
  stroke-width: 2px;
`
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  width: 23px;
  height: 21px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  opacity:-1;
`

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 23px;
  height: 21px;
  border-radius: 2px;
  border: solid 1px rgba(18, 36, 66, 0.2);
  background: ${(props: IRootProps) => props.checked ? '#ffffff' : '#fffffff'};
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    border-radius: 2px;
    border: solid 1px #122442;
  }
  ${Icon} {
    visibility: ${(props: IRootProps) => props.checked ? 'visible' : 'hidden'};
  }
`
export const Label = styled.label`
  margin-left: 15px; 
  font-size: 16px;
  font-weight: normal;
  color: ${C.DARK_GRAY};
`